import { render } from "./MovieLayout.vue?vue&type=template&id=3ac3c59d"
import script from "./MovieLayout.vue?vue&type=script&lang=js"
export * from "./MovieLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__